import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "right-content" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "header d-md-none" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "SMSDD Admin")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_router_view)
  ]))
}